import {useContext, useEffect} from 'react'
import {Col, Flex, Form, Modal, Row} from 'antd'
import {useIntl} from 'react-intl'
import {postRequest} from '../../../../services/base'
import {NavContext} from '../../../../context/global_context'
import {PlantContext, SET_SHOW_PLANT_POPUP} from '../context/context'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'

const PlantFormModal = (props) => {
  const intl = useIntl()
  const [state, dispatch] = useContext(PlantContext)
  const [, navDispatch] = useContext(NavContext)
  const [form] = Form.useForm()

  const selected = state?.selected_plant || {}

  const closeFormPopup = () => {
    dispatch({ type: SET_SHOW_PLANT_POPUP, data: false })
    form.resetFields()
  }

  const getInitialValues = () => ({
    is_create: !selected?.id,
    id: selected?.id || undefined,
    name: selected?.name || '',
    vin_identifier: selected?.vin_identifier || '',
    time_zone: selected?.time_zone || '',
    location: selected?.location || '',
    make: selected?.make || '',
  })

  useEffect(() => {
    if (!state.show_plant_popup) return
    form.setFieldsValue(getInitialValues())
  }, [state.show_plant_popup])

  const savePlant = async (values) => {
    const formData = new FormData()
    formData.append('is_create', values.is_create ? 'true' : 'false')
    if (values.id) {
      formData.append('id', values.id)
    }
    formData.append('name', values.name)
    formData.append('vin_identifier', values.vin_identifier || '')
    formData.append('time_zone', values.time_zone || '')
    formData.append('location', values.location || '')
    formData.append('make', values.make || '')

    let res = await postRequest(`/api/plants/save_plants/`, formData)
    if (res?.errors && Object.keys(res.errors).length > 0) {
      const msg = Object.values(res.errors).flat().join(', ')
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg || intl.formatMessage({ id: 'plants.saveError' }),
        },
      })
    } else if (res?.status === false) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({ id: 'plants.saveError' }),
        },
      })
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({ id: 'plants.saveSuccess' }),
        },
      })
      props.getPlantListData()
      closeFormPopup()
    }
  }

  return (
    <Modal
      open={state.show_plant_popup}
      title={
        selected?.id
          ? intl.formatMessage({ id: 'plants.updateTitle' })
          : intl.formatMessage({ id: 'plants.createTitle' })
      }
      width="50%"
      className="plants-form-modal"
      centered={true}
      footer={null}
      closable={true}
      onCancel={closeFormPopup}
    >
      <div className="container">
        <Form
          id="plant-form"
          name="plant-form"
          form={form}
          layout="vertical"
          onFinish={savePlant}
        >
          <InputText name="is_create" hidden={true} isRequired={false} />
          <InputText name="id" hidden={true} isRequired={false} />
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <InputText
                name="name"
                label={intl.formatMessage({ id: 'plants.name' })}
                isRequired={true}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="vin_identifier"
                label={intl.formatMessage({ id: 'plants.vinIdentifier' })}
                isRequired={false}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="time_zone"
                label={intl.formatMessage({ id: 'plants.timeZone' })}
                isRequired={false}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="location"
                label={intl.formatMessage({ id: 'plants.location' })}
                isRequired={false}
              />
            </Col>
            <Col span={12}>
              <InputText
                name="make"
                label={intl.formatMessage({ id: 'plants.make' })}
                isRequired={false}
              />
            </Col>
            <Col span={24}>
              <Flex justify="end" className="py-4">
                <Button htmlType="submit" type="primary">
                  {intl.formatMessage({ id: 'plants.save' })}
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default PlantFormModal
